import { type ComponentProps } from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const paperFloatingVariants = cva("bg-card", {
  variants: {
    surface: {
      default: "rounded-sm border-0 shadow-lg",
      console:
        "rounded-[10px] border border-(--console-border) bg-card shadow-none",
    },
  },
  defaultVariants: {
    surface: "default",
  },
});

type PaperFloatingProps = ComponentProps<"div"> &
  VariantProps<typeof paperFloatingVariants>;

const PaperFloating = ({
  className,
  surface,
  ref,
  ...props
}: PaperFloatingProps) => (
  <div
    ref={ref}
    className={cn(paperFloatingVariants({ surface }), className)}
    {...props}
  />
);
PaperFloating.displayName = "PaperFloating";

export { PaperFloating };
